/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import "babel-polyfill";

window.Vue = require('vue');
import VueCookies from 'vue-cookies';
import route from './route'



Vue.use(VueCookies)	

// matomo tag manager analitics script
const analitycsConsented = VueCookies.get("analytics-consent") == null ? false : (VueCookies.get("analytics-consent") == "true" ? true : false);
if (analitycsConsented) {
    // create script element and set attributes
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    const scriptElement = document.createElement("script");
    scriptElement.setAttribute("type", "text/javascript");
    scriptElement.setAttribute("src", "https://matomo.rokus-klett.si/js/container_rdkiSvGA.js");
    document.head.prepend(scriptElement);

    // create noscript element and set attributes
    const noScriptElement = document.createElement("noscript");
    const iframeElement = document.createElement("iframe");
    iframeElement.setAttribute("src", "https://matomo.rokus-klett.si/js/container_rdkiSvGA.js");
    iframeElement.setAttribute("height", "0");
    iframeElement.setAttribute("width", "0");
    iframeElement.setAttribute("style", "display:none;visibility:hidden");
    noScriptElement.appendChild(iframeElement);
    document.body.prepend(noScriptElement);
}

Vue.component('cookie-consent', require('./components/CookieConsent.vue'));
Vue.component('cookie-consent-details', require('./components/CookieConsentDetails.vue'));
Vue.component('browser', require('./components/Browser.vue'));
Vue.component('audio-library', require('./components/AudioLibrary.vue'));
Vue.component('audio-block', require('./components/AudioBlock.vue'));
Vue.component('audio-list', require('./components/AudioList.vue'));
Vue.component('audio-player', require('./components/AudioPlayer.vue'));
Vue.component('modal', require('./components/Modal.vue'));
Vue.component('collection', require('./components/Collection.vue'));
Vue.component('subcollection', require('./components/Subcollection.vue'));
Vue.component('login', require('./components/Login.vue'));
Vue.component('dropdown', require('./components/Dropdown.vue'));
Vue.component('dropdown-main', require('./components/DropdownMain.vue'));
Vue.component('q-mark', require('./components/QMark.vue'));


Vue.mixin({
	methods: {
		route
	}
});


var app = new Vue({
  el: '#app',
  mounted() {
    this.init();
  },
  methods: {
      init() {
        const popupConsented = this.$cookies.get("site-popup-consent") == null ? false : (this.$cookies.get("site-popup-consent") == "true" ? true : false);
        if (popupConsented) {
            // this.$root.$emit('add-popup', PopupKonferenca);
        }
        // morebitni ostanki cookie-jev iz prejšnjih obiskov
        const cookiesToDelete = ["_ga", "_gat", "_gid", "_fbp"];
        if (this.$cookies.get("_ga") != null) {
            cookiesToDelete.forEach(cookie => {
                this.$cookies.remove(cookie);
            });
        }
    },
    showConsent() {
      this.$root.$emit('show-consent');
		}
  }
});

window.app = app;


// WEBPACK FOOTER //
// ./resources/assets/js/app.js